// Scroll-reveal driver.
//
// This script has NO knowledge of the page structure — it only understands two
// behaviors, opted into from the markup with a data attribute:
//
//   data-reveal            → the element reveals as one block.
//   data-reveal="stagger"  → the element's direct children each reveal,
//                            staggered (the container itself does not).
//
// For every revealed element it adds a `.reveal` hook class (the CSS owns the
// actual transition) and sets `--reveal-i` for the stagger delay, then toggles
// `.is-in` as the element scrolls into view.
//
// Fully gated behind prefers-reduced-motion: if the user opts out, nothing is
// tagged and no observer runs, so the CSS animations (also guarded in the
// stylesheet) never apply and content is shown statically.
(function() {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function tag(el, i) {
        if (!el || el.classList.contains('reveal')) return;
        el.classList.add('reveal');
        // stagger via inline custom prop the CSS reads
        el.style.setProperty('--reveal-i', (i % 8).toString());
    }
    document.addEventListener('DOMContentLoaded', function() {
        if (prefersReduced) return; // honor opt-out: leave everything static
        var targets = [];
        document.querySelectorAll('[data-reveal]').forEach(function(el) {
            if (el.getAttribute('data-reveal') === 'stagger') // reveal each direct child, staggered; the container stays put
            Array.prototype.forEach.call(el.children, function(child, i) {
                tag(child, i);
                targets.push(child);
            });
            else {
                // reveal the element itself as a single block
                tag(el, 0);
                targets.push(el);
            }
        });
        if (!targets.length) return;
        if (!('IntersectionObserver' in window)) {
            targets.forEach(function(el) {
                el.classList.add('is-in');
            });
            return;
        }
        var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-in');
                    io.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -8% 0px',
            threshold: 0.06
        });
        targets.forEach(function(el) {
            io.observe(el);
        });
    });
})();

//# sourceMappingURL=repo.bdef1ac5.js.map
